import { MenuItem } from "@headlessui/react";
import { Link } from "react-router-dom";

import { ROUTES } from "~/router/constants";
import { useLogout } from "~/screens/Auth/hooks/useLogout";
import { useNavigationStore } from "~/stores";
import { customIcons, icons } from "~/ui";

interface Navigation {
  name: string;
  href?: string;
  icon: any;
  onClick?: () => void;
}

const useNavigation = (): Navigation[] => {
  const { mutate: logout } = useLogout();

  return [
    {
      name: "Account settings",
      href: ROUTES.hubProfile,
      icon: icons.outline.Cog6ToothIcon,
    },
    {
      name: "Log out",
      icon: customIcons.LogoutIcon,
      onClick: logout,
    },
  ];
};

interface ItemProps {
  item: Navigation;
  close?: () => void;
}

const Item = ({ item, close }: ItemProps) => {
  const { closeSidebar } = useNavigationStore();

  const className =
    "block cursor-pointer px-3 py-1 text-[16px] data-focus:bg-gray-50 data-focus:outline-hidden";

  const handleOnClick = () => {
    item.onClick?.();
    close?.();
    closeSidebar();
  };

  return (
    <div className="text-indigo hover:bg-light-lavender-gray hover:text-indigo flex items-center rounded-sm px-2">
      <item.icon aria-hidden="true" className="w-6 shrink-0" />

      {item.href ? (
        <Link to={item.href} className={className} onClick={handleOnClick}>
          {item.name}
        </Link>
      ) : (
        <button className={className} onClick={handleOnClick}>
          {item.name}
        </button>
      )}
    </div>
  );
};

export const UserDropdownNavigation = () => {
  const navigation = useNavigation();

  return (
    <div className="flex flex-col gap-2 px-7 py-4">
      {navigation.map((item) => (
        <MenuItem key={item.name}>
          {({ close }) => <Item item={item} close={close} />}
        </MenuItem>
      ))}
    </div>
  );
};

export const UserDrawerNavigation = () => {
  const navigation = useNavigation();

  return (
    <div className="flex flex-col gap-2">
      {navigation.map((item, index) => (
        <Item key={index} item={item} />
      ))}
    </div>
  );
};
